import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { history } from 'Store';
import { signOutAction } from 'Store/modules/auth/actions';
import useTranslation from 'Hooks/useTranslation';
import ThreeColLayout from 'Components/Layouts/ThreeColLayout';
import { slideIn } from 'Styles/utils/utils';
import { routes } from 'Constants/routes';
import AccountContent from './components/AccountContent';
import AccountMenu from './components/AccountMenu';
import AccountPrivacy from './components/AccountPrivacy';
import AccountProfile from './components/AccountProfile';
import * as Styled from './styles';
import AccountSubscription from './components/AccountSubscription';

const ACCOUNT_CONTENT_ID = 'account_content';

const contentScreens = {
  1: AccountProfile,
  2: AccountPrivacy,
  3: AccountSubscription,
};

const Account = (): JSX.Element => {
  const [screen, setScreen] = useState(1);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const path = history.location.pathname;
  const goToScreen = (value: number): void => {
    setScreen(value);
    slideIn(`#${ACCOUNT_CONTENT_ID}`);
    if (
      path === routes.ACCOUNT_RFC ||
      path === routes.ACCOUNT_EFIRMA ||
      path === routes.ACCOUNT_DELETE_FORM ||
      path === routes.ACCOUNT_DELETE_INFO ||
      path === routes.ACCOUNT_SUBSCRIPTION
    ) {
      history.push(routes.ACCOUNT);
    }
  };

  const onLogout = (): void => {
    dispatch(signOutAction());
  };

  const links = [
    { label: 'account:Account.links.5', action: () => goToScreen(3) },
    { label: 'account:Account.links.1', action: () => goToScreen(1) },
    { label: 'account:Account.links.3', action: () => goToScreen(2) },
  ];

  return (
    <ThreeColLayout>
      <AccountMenu title="Account.title" links={links}>
        <Styled.LogOutButton type="button" onClick={onLogout}>
          {t('account:SignOut.label')}
        </Styled.LogOutButton>
      </AccountMenu>
      <AccountContent id={ACCOUNT_CONTENT_ID} screen={screen} contentScreens={contentScreens} />
    </ThreeColLayout>
  );
};
export default Account;
